import { h, Fragment } from 'preact'; /** @jsx h */
import { useState, useEffect } from 'preact/hooks';
import { updateCheck } from './generalVariables';
import { strDateYYYYmmDD, strDateHHMM, isValidDate } from './dateVariables';
import { sortThis } from './generalVariables';
import { GhostBtn, DeleteBtn } from './generalComponentsButtons';
import './generalComponentsInput.scss';

export const SelectField = (props) => {
    const {
        sValue,
        name,
        onChange,
        label,
        hasEmptyVal,
        optArray,
        optValField,
        optValTxt,
        required,
        includeNameChange
    } = props;
    return (
        <label className={`${props.className || ''} inputfield`}>
            <span>
                {label} {required && '*'}
            </span>
            <select
                name={name}
                value={sValue}
                onChange={(e) =>
                    includeNameChange
                        ? onChange(e.target.value, name)
                        : onChange(e.target.value)
                }
                required={required}
            >
                {hasEmptyVal && <option value=""></option>}
                {optArray.map((opt) => {
                    return (
                        <option value={optValField ? opt[optValField] : opt}>
                            {optValTxt ? opt[optValTxt] : opt}
                        </option>
                    );
                })}
            </select>
        </label>
    );
};

export const DateField = (props) => {
    const [viewDate, setViewDate] = useState();
    const {
        label,
        name,
        value,
        onChange,
        min,
        max,
        required,
        hasStartVal
    } = props;
    const minStr = min ? strDateYYYYmmDD(min) : '';
    const maxStr = max ? strDateYYYYmmDD(max) : '';
    const hourStr = strDateHHMM(value);

    useEffect(() => {
        if (!viewDate && hasStartVal && value != null) {
            setViewDate(strDateYYYYmmDD(value));
        }
    }, []);
    useEffect(() => {
        if (
            viewDate &&
            hasStartVal &&
            viewDate !== strDateYYYYmmDD(value) &&
            value != null
        ) {
            setViewDate(strDateYYYYmmDD(value));
        }
    }, [value]);

    const returnChange = (e) => {
        const dateFormatted = new Date(`${e.target.value} ${hourStr}`);
        setViewDate(e.target.value);
        if (isValidDate(dateFormatted)) onChange(dateFormatted);
    };
    return (
        <label className="inputfield">
            <span>
                {label} {required && '*'}
            </span>
            <input
                type="date"
                name={name}
                value={viewDate}
                onChange={(e) => returnChange(e)}
                min={minStr ? minStr : false}
                max={maxStr ? maxStr : false}
                required={required}
            />
        </label>
    );
};

export const Dropdown = ({
    label,
    name,
    value,
    onChange,
    options,
    required
}) => {
    const handleChange = (value) => {
        onChange(value);
    };

    return (
        <label className="inputfield">
            <span>
                {label} {required && '*'}
            </span>
            <select
                name={name}
                value={value}
                onChange={(e) => handleChange(e.target.value)}
                required={required}
            >
                {options.map((option, index) => (
                    <option key={index} value={option}>
                        {option}
                    </option>
                ))}
            </select>
        </label>
    );
};

export const HourField = (props) => {
    const { label, name, value, onChange, min, max, required } = props;
    const valStringed = strDateHHMM(value);
    const minStr = min ? strDateHHMM(min) : '';
    const maxStr = max ? strDateHHMM(max) : '';

    const returnChange = (e) => {
        const valDate = strDateYYYYmmDD(value);
        const dateFormatted = new Date(`${valDate} ${e.target.value}`);
        onChange(dateFormatted);
    };
    return (
        <label className="inputfield">
            <span>
                {label} {required && '*'}
            </span>
            <input
                type="time"
                name={name}
                value={valStringed}
                onChange={(e) => returnChange(e)}
                min={minStr ? minStr : false}
                max={maxStr ? maxStr : false}
                required={required}
            />
        </label>
    );
};

export const TextField = (props) => {
    const {
        label,
        name,
        value,
        placeholder,
        onSetChange,
        required,
        isArea,
        areaRows,
        areaCols,
        disabled
    } = props;

    const changeTxt = (e) => {
        if (
            e &&
            e.target &&
            (e.target.value || e.target.value === '') &&
            typeof e.target.value === 'string'
        ) {
            onSetChange(e.target.value);
        }
    };
    return (
        <label className="inputfield">
            <span>
                {label}
                {required && '*'}
            </span>
            {isArea ? (
                <textarea
                    {...props}
                    rows={areaRows || 4}
                    cols={areaCols || 50}
                    name={name}
                    value={value}
                    placeholder={placeholder || ''}
                    onkeyup={(e) => changeTxt(e)}
                    required={required}
                    autoComplete="off"
                />
            ) : (
                <input
                    {...props}
                    type="text"
                    name={name}
                    value={value}
                    placeholder={placeholder || ''}
                    onInput={(e) => changeTxt(e)}
                    required={required}
                    autoComplete="off"
                    disabled={disabled}
                />
            )}
        </label>
    );
};

export const Hiddenfield = (props) => {
    const { name, value } = props;
    return (
        <input
            className="inputfield"
            {...props}
            name={name}
            value={value}
            type="hidden"
        />
    );
};

export const CheckBox = (props) => {
    const { label, name, checked, onChange, className } = props;
    return (
        <label className={`inputfield checkBox-input ${className || ''}`}>
            <input
                {...props}
                type="checkbox"
                name={name}
                checked={checked}
                onChange={(e) => onChange(e.target.checked, name)}
            />
            <span>{label || ''}</span>
            {props.children}
        </label>
    );
};

export const Slider = (props) => {
    const { leftSide, rightSide, value, name, changeValue, className } = props;

    const onChange = (checked) => {
        const val = checked ? rightSide : leftSide;
        changeValue(val, name);
    };

    return (
        <label className={`inputfield switch ${className || ''}`}>
            <span className="labels">{leftSide}</span>
            <input
                {...props}
                type="checkbox"
                name={name}
                checked={value === rightSide}
                onChange={(e) => onChange(e.target.checked)}
            />
            <span className="slider round"></span>
            <span className="labels">{rightSide}</span>
        </label>
    );
};

export const Select = (props) => {
    //gives you the option of defining the field of contents - also have a default name that will be default,
    const {
        label,
        name,
        arrayToMap,
        checkedField,
        labelField,
        labelExtra,
        disabledField,
        nameField,
        onChange,
        required,
        isMultiple,
        placeHolder,
        customSort
    } = props;
    const [searchStr, setSearchStr] = useState('');
    const [options, setOptions] = useState([]);
    const [checkedOnes, setCheckedOnes] = useState([]);
    const [showOptions, setShowOptions] = useState(false);
    const [allIsChecked, setAllIsChecked] = useState(false);
    const [showMoreSelected, setShowMoreSelected] = useState(false);
    useEffect(() => {
        let opst = arrayToMap;
        if (!props.ignoreSort && customSort == undefined) {
            opst = sortThis(arrayToMap, {
                key: labelField,
                direction: 'asc'
            });
        } else if (customSort) {
            opst.sort(function (a, b) {
                if (a.navn.split('(').length == 1) return 1;
                if (b.navn.split('(').length == 1) return -1;
                let aB = a.navn.split('(')[1].slice(0, -1);
                let bB = b.navn.split('(')[1].slice(0, -1);
                let aLabel = a.navn.split('(')[0];
                let bLabel = b.navn.split('(')[0];
                if (aB > bB) return 1;
                if (aB < bB) return -1;
                if (aB == bB && aLabel > bLabel) return 1;
                if (aB == bB && aLabel < bLabel) return -1;
                return 0;
            });
        }
        setOptions(opst);
        const checkedList = opst.filter((op) => op.checked);
        setCheckedOnes(checkedList);
        const visibleOnes = opst.filter(
            (itm) => itm.disabled !== true && itm.hideSearch !== true
        );
        const visibleChecked = visibleOnes.filter((op) => op.checked);
        if (visibleOnes.length === visibleChecked.length) setAllIsChecked(true);
    }, [arrayToMap, labelField]);

    useEffect(() => {
        document.addEventListener('keydown', escapeFunction, false);
        return () => {
            document.removeEventListener('keydown', escapeFunction, false);
        };
    }, []);

    const changeCheck = (nameVal, eventBool) => {
        const newArr = updateCheck(
            options,
            checkedField || 'checked',
            nameField || 'name',
            nameVal,
            eventBool,
            isMultiple
        );

        onChange(newArr);
    };

    const checkAllFilter = () => {
        let newArr;
        if (allIsChecked) {
            newArr = options.map((item) => {
                return {
                    ...item,
                    checked: item.disabled ? item.checked : false
                };
            });
        } else {
            newArr = options.map((item) => {
                return {
                    ...item,
                    checked: item.disabled ? item.checked : true
                };
            });
        }
        onChange(newArr);
        setAllIsChecked(!allIsChecked);
    };
    const unCheckAll = (e) => {
        e.preventDefault();

        const newArr = options.map((item) => {
            return { ...item, checked: false };
        });
        onChange(newArr);
        setAllIsChecked(false);
    };

    const updateSearchStr = (value) => {
        if (typeof value === 'string') {
            setSearchStr(value);
            const updateArr = options.map((item) => {
                const includesSearch =
                    `${item[labelField] || item.label} ${
                        item[labelExtra] || ''
                    }`
                        .toUpperCase()
                        .includes(value.toUpperCase()) ||
                    (item[nameField] || item.name)
                        .toString()
                        .toUpperCase()
                        .includes(value.toUpperCase());
                return { ...item, hideSearch: !includesSearch };
            });
            setOptions(updateArr);
            setCheckedOnes(updateArr.filter((op) => op.checked));
        }
    };

    const escapeFunction = (event) => {
        if (event.keyCode === 27) {
            setShowOptions(false);
        }
    };

    return (
        <fieldset className="multiple-select inputfield">
            <TextField
                label={`${label}${required ? ' *' : ''}`}
                name={name}
                value={searchStr}
                placeholder={placeHolder || 'velg eller søk...'}
                onSetChange={updateSearchStr}
                onFocus={(_) => setShowOptions(true)}
                autoComplete="off"
            />
            <div className={`items-area${showOptions ? '' : ' hidden'}`}>
                {options.length === 0 && (
                    <p className="no-matches">Ingen treff</p>
                )}
                {isMultiple && (
                    <button
                        type="button"
                        className="btn-select-all"
                        onClick={() => checkAllFilter()}
                    >
                        {allIsChecked
                            ? 'Fjern alle (i filter)'
                            : 'Velg alle (i filter)'}
                    </button>
                )}
                <GhostBtn
                    label="X"
                    className="close-btn"
                    onClick={(_) => setShowOptions(false)}
                    title="Skjul"
                />
                {options.map((itm) => {
                    return (
                        <label
                            className={`checkbox-item${
                                itm.disabled || itm.hideSearch ? ' hidden' : ''
                            }`}
                        >
                            <input
                                type="checkbox"
                                name={itm[nameField] || itm.name}
                                checked={itm[checkedField] || itm.checked}
                                onChange={(e) =>
                                    changeCheck(
                                        itm[nameField] || itm.name,
                                        e.target.checked
                                    )
                                }
                                disabled={itm[disabledField] || itm.disabled}
                            />
                            <span>
                                {itm[labelField] || itm.label}{' '}
                                {itm[labelExtra] && (
                                    <Fragment>
                                        {' '}
                                        <br /> {itm[labelExtra]}
                                    </Fragment>
                                )}
                            </span>
                        </label>
                    );
                })}
            </div>
            <div className="selected-items">
                <p>Valgt ({checkedOnes.length}): </p>
                {checkedOnes.map((opt, indx) => (
                    <Fragment>
                        {(indx < 8 || showMoreSelected) && (
                            <div>
                                <p>{opt[labelField] || opt.label}</p>
                                <span
                                    onClick={(_) =>
                                        changeCheck(
                                            opt[nameField] || opt.name,
                                            false
                                        )
                                    }
                                >
                                    X
                                </span>
                            </div>
                        )}
                    </Fragment>
                ))}
                <div className="block-view">
                    {checkedOnes.length > 8 && (
                        <GhostBtn
                            className={`btn-show-hide-checked ${
                                showMoreSelected ? 'show-less' : 'show-more'
                            }`}
                            onClick={(_) =>
                                setShowMoreSelected(!showMoreSelected)
                            }
                            label={showMoreSelected ? 'Vis mindre' : 'Vis mer'}
                        ></GhostBtn>
                    )}
                    {checkedOnes.length > 0 && isMultiple && (
                        <DeleteBtn
                            className={`btn-uncheck-all`}
                            onClick={(e) => unCheckAll(e)}
                            label="Fjern alle"
                        />
                    )}
                </div>
            </div>
        </fieldset>
    );
};

export const GenericDropdown = (props) => {
    const { options, selected, setSelected, label } = props;

    const handleChange = (event) => {
        const selectedItem = options.find(
            (item) => item.value.toString() === event.target.value
        );
        setSelected(selectedItem);
    };
    const [isOpen, setIsOpen] = useState(false);

    return (
        <Fragment>
            <span className="gdd-label">{label}</span>
            <div className="genericdropdown" onClick={() => setIsOpen(!isOpen)}>
                <div className="gdd-selected-item">
                    {selected.label}
                    <span
                        className={`gdd-caret ${isOpen ? 'open' : ''}`}
                    ></span>{' '}
                </div>
                {isOpen && (
                    <ul className={`gdd-options-list`}>
                        {options.map((item) => (
                            <li
                                key={item.value}
                                onClick={() => setSelected(item)}
                                className="gdd-option-item"
                            >
                                {item.label}
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </Fragment>
    );
};

/*
* example:
    const tryData = setCheckedAndDisabled([
        { label: 'WITESP', name: 'WITESP' },
        { label: 'KLEOIV', name: 'KLEOIV' },
        { label: 'HOVTOR', name: 'HOVTOR' },
        { label: 'KROAND', name: 'KROAND' },
        { label: 'MYRFRO', name: 'MYRFRO' }
    ]);
    const [testData, setTestData] = useState(tryData);
    const changeTestData = (checked, nameField, nameVal, eventBool) => {
        const arr = updateCheck(
            testData,
            checked,
            nameField,
            nameVal,
            eventBool
        );
        setTestData(arr);
    };
    <Select
        label="Crew"
        name="crewselect"
        arrayToMap={testData}
        onChange={changeTestData}
    />
* */
